import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";

export const getOtherOrder = params => {
  return axios.request({
    url: "/overseaOrder/getOverseaOrderList",
    method: "get",
    params
  });
};

export function updateSheet(data) {
  return axios.request({
    url: "/overseaOrder/labelUpload",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
}

export const getSummaryData = params => {
  return axios.request({
    url: "/doubleClearance/getSummary",
    method: "get",
    params
  });
}

export const getMyCustomer = () => {
  return axios.request({
    url: "/doubleClearance/getMyCustomer",
    method: "get"
  });
}
